import Chip from '@mui/material/Chip';
import { useTranslation } from 'react-i18next';

import { LanguageKeys } from 'src/common/constants/languages';
import { IRole } from 'src/interfaces/Role';

interface Props {
  role?: IRole;
}

const UserRoleChip = ({ role }: Props) => {
  const {
    i18n: { resolvedLanguage },
  } = useTranslation();
  const currentLang = resolvedLanguage as LanguageKeys;
  const label = role?.i18n?.[currentLang] || role?.name || String(role?.roleId ?? '');

  if (!label) return null;

  return <Chip label={label} size="small" variant="outlined" />;
};

export default UserRoleChip;
